'use strict';

function CnRoundFormController($q, $log) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.onFormChange = onFormChange;
  vm.onFormSubmit = onFormSubmit;
  vm.onFormReset = onFormReset;

  vm._submitResponseOk = _submitResponseOk;
  vm._submitResponseFailed = _submitResponseFail;

  function $onInit() {
    vm.onSubmit = vm.onSubmit() || $q.reject;
    vm.onChange = vm.onChange() || $q.resolve;
    vm.onReset = vm.onReset() || $q.resolve;
    vm.questionnaires = vm.questionnaires || [];
    vm.modal = vm.modal === true || false;
    vm.submitting = false;
    vm.isPerformanceReview = vm.isPerformanceReview === true || false;
    vm.performanceReviewRound = undefined;
    vm.performanceReviewRounds = vm.performanceReviewRounds || [];

    if (vm.data) {
      vm.questionnaire = vm.data.questionnaire || -1;
      vm.description = vm.data.description || '';
      vm.goals = vm.isPerformanceReview ? vm.data.goals || '' : '';

      var filteredRounds = vm.performanceReviewRounds.filter(function(round) {
        return round.id === vm.data.assessment_round;
      });

      if (filteredRounds.length > 0) {
        vm.performanceReviewRound = filteredRounds[0];
      }
    }
  }

  function onFormSubmit() {
    vm.submitting = true;

    vm.onSubmit(vm.questionnaire, vm.description, vm.goals, vm.performanceReviewRound)
      .then(vm._submitResponseOk)
      .catch(vm._submitResponseFailed)
      .finally(function() {
        vm.submitting = false;
      });
  }

  function onFormReset() {
    return vm.onReset();
  }

  function onFormChange() {
    return vm.onChange(vm.questionnaire, vm.description, vm.goals, vm.performanceReviewRound)
      .then(function() { vm.form.description.$setValidity('unique', true); })
      .catch(function() { vm.form.description.$setValidity('unique', false); });
  }

  function _submitResponseOk() {
    vm.description = '';
    vm.goals = '';
    vm.performanceReviewRound = undefined;

    if (vm.form) {
      vm.form.$setPristine();
    }
  }

  function _submitResponseFail(err) {
    $log.error('err', err);
  }
}

module.exports = CnRoundFormController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-round-form/cn-round-form.controller.js
 ** module id = 87
 ** module chunks = 0
 **/